import React, { Fragment } from "react";
import "./styles.css";
import { getRestaurantCheckInURLWithTableIdForm } from "common/utils/route-util";
import { ReactComponent as MagilhubLogo } from "common/assets/svg/magilhubLogoCheckin.svg";
import { ReactComponent as CancelIcon } from "common/assets/svg/cancel.svg";
import { useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import { CHECKIN_TABLE_ID } from "common/constants";

import { useHistory, useParams } from "react-router";

function CheckInFloatingCart(props: any) {
  const history = useHistory();
  let { merchantSlug } = useParams<any>();
  const { checkInFloatingBar, setcheckInFloatingBar } = props;
  const showCart = useSelector(
    (state: RootState) => state.cart.showFloatingCart
  );

  const tableId = localStorage.getItem(CHECKIN_TABLE_ID);

  return (
    <Fragment>
      <div
        className="checkin-status-row"
        style={{ top: showCart ? "86%" : "90%" }}
      >
        <div id="checkin-status-container">
          <div className="checkInfloatingCartButtonInnerContainer">
            <MagilhubLogo />
            <div className="checkInFloatingCartTextContainer">
              <span id="res-status-name">CheckIn !</span>
              <p className="checkIn-offerText">
                To get offers and promotional content
              </p>
            </div>
          </div>

          <div className="checkInfloatingCartButtonContainer">
            <span
              className="checkIn-button"
              onClick={() => {
                tableId &&
                  history.push({
                    pathname: getRestaurantCheckInURLWithTableIdForm(
                      merchantSlug,
                      tableId
                    ),
                    state: { query: "tableCheckIn" },
                  });
              }}
            >
              Checkin
            </span>
          </div>
          <span
            onClick={() => {
              setcheckInFloatingBar(false);
            }}
          >
            <CancelIcon className="checkin-cart-cancel-icon" />
          </span>
        </div>
      </div>
    </Fragment>
  );
}

export default CheckInFloatingCart;
